import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";

function TabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/bins/${props.id}/${e.target.value}`);
  };

  return (
    <div>
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="summary" style={{ marginRight: 5 }}>
          Summary
        </Radio.Button>
        <Radio.Button value="sub-bins" style={{ marginRight: 5 }}>
          Sub-Bins
        </Radio.Button>
        <Radio.Button value="items" style={{ marginRight: 5 }}>
          Stock Items
        </Radio.Button>
      </Radio.Group>
    </div>
  );
}

export default TabMenu;
